
import styles from './About.module.scss'
import React, {useState} from "react";
import {PageProps} from "@/types";
import {Person} from "@/types/person";
import {InteractionStats} from "@/types/interactionStats";
import AboutComponent from '@/Molecules/FoldableText/About'
import Characteristics from "@/Molecules/Person/Characteristics";


export default function About(person: Person) {
  const [open, setOpen] = useState(false)

  return <div className={styles.about}>
    <div></div>
    {person.about?.length > 10 && <>
      <a id={'about'}></a>
      <AboutComponent text={person.about} title={`Over ${person.name}`} className={'mb-5'}/>
    </>}

    {person.characteristics?.length > 0 && (<>
      <a id={'characteristics'}></a>
      <Characteristics characteristics={person.characteristics}/>
    </>)}
  </div>
}
